function AppName() {
    return (
        <>
            Character Forge
        </>
    );
}

export default AppName;